// AURAX_REDESIGN_2710 (GROK2): lê os switches das abas novas (private/<NOME>_OFF no backend).
import { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../apiBase';

const OFF = { teste_1clique: false, financeiro_aba: false, renovacao_template: false, atendimento_espelho: false };
let cache = null;
let inflight = null;
// QT_GRID_CACHE_2810 + HOME_LIMPA_2810 (GROK2): flags salvas no navegador = tela pronta sem esperar
// a rede (atualiza em 2º plano). home_limpa liga a classe que esconde os itens marcados com X.
const FLAGS_LS = 'aurax_flags_v1';
let stale = null;
function applyBody(f) {
  try { document.body.classList.toggle('aurax-home-limpa', !!(f && f.home_limpa)); document.body.classList.toggle('aurax-menu-ordem', !!(f && f.menu_ordem)); document.body.classList.toggle('aurax-paginas-limpas', !!(f && f.paginas_limpas)); document.body.classList.toggle('aurax-agrupa-mobile', !!(f && f.agrupa_mobile)); /* AGRUPA_MOBILE_2810 */ } catch (_) { /* noop */ }
}
try { stale = JSON.parse(window.localStorage.getItem(FLAGS_LS) || 'null'); if (stale) applyBody(stale); } catch (_) { stale = null; }

export function fetchAuraxFlags() {
  if (cache) return Promise.resolve(cache);
  if (!inflight) {
    inflight = axios
      .get(`${API_BASE_URL}/api/aurax/flags`, { withCredentials: true, timeout: 15000 })
      .then(async ({ data }) => {
        cache = { ...OFF, ...(data || {}) };
        // EQUIPE_DONO_0211: Equipe (/team) aberta p/ revenda + dono de equipe isento da trava de saldo 0 (só telas de leitura).
        try {
          const eq = (await axios.get(`${API_BASE_URL}/api/equipe-paineis`, { withCredentials: true, timeout: 10000 })).data || {};
          if (eq.equipe) {
            cache.equipe_0211 = true;
            cache.filtro_revenda_0311 = eq.filtro_revenda === true; // EQUIPE_V2_0311 (backend novo)
            cache.teste_painel_0311 = eq.teste_painel === true;
            cache.equipe_dono_0211 = Array.isArray(eq.paineis) && eq.paineis.length > 0 && eq.isencao_saldo_0211 !== false;
            if (Array.isArray(cache.extras_hide_2910)) cache.extras_hide_2910 = cache.extras_hide_2910.filter((h) => h !== '/team');
            if (Array.isArray(cache.extras_added_2910) && !cache.extras_added_2910.includes('equipe')) cache.extras_added_2910 = [...cache.extras_added_2910, 'equipe'];
          }
        } catch (_) { /* sem equipe = comportamento antigo */ }
        applyBody(cache);
        try { if (cache.flags_cache === false) window.localStorage.removeItem(FLAGS_LS); else window.localStorage.setItem(FLAGS_LS, JSON.stringify(cache)); } catch (_) { /* noop */ }
        return cache;
      })
      .catch(() => OFF) // erro = comportamento antigo
      .finally(() => { inflight = null; });
  }
  return inflight;
}
try { if (window.location.pathname.startsWith('/dashboard')) fetchAuraxFlags(); } catch (_) { /* noop */ }

// EXTRAS_FIX_2910: ao trocar de conta (login, logout, entrar como revenda) as flags são por usuário.
const subs2910 = new Set();
export function resetAuraxFlags() {
  cache = null; stale = null; inflight = null;
  try { window.localStorage.removeItem(FLAGS_LS); } catch (_) { /* noop */ }
  subs2910.forEach((fn) => fn(null));
  fetchAuraxFlags().then((f) => subs2910.forEach((fn) => fn(f)));
}

export function useAuraxFlags() {
  const [flags, setFlags] = useState(cache || stale);
  useEffect(() => {
    let alive = true;
    const sub = (f) => alive && setFlags(f);
    subs2910.add(sub);
    fetchAuraxFlags().then((f) => alive && setFlags(f));
    return () => { alive = false; subs2910.delete(sub); };
  }, []);
  return flags; // null enquanto carrega
}
